// extracted by mini-css-extract-plugin
export default {"FondGris":"FondGris_FondGris__Eq+xD"};